import type { OtpFlowName, OtpVerificationParams } from "./types";

export const otpVerificationChannels = [
  "SMS",
  "USER_EMAIL",
  "USER_MOBILE_SMS",
] as const;

export const otpVerificationPurposes = [
  "SignupMobileVerification",
  "MobileNumberUpdate",
  "MobileNumberVerification",
] as const;

export const OTP_FLOW = {
  SIGNUP: "signup",
  UPDATE_PHONE_NUMBER: "updatePhoneNumber",
  VERIFY_EXISTING: "verifyExisting",
  WITHDRAW: "withdraw",
} as const;

export const otpFlowTracking: Record<OtpFlowName, OtpVerificationParams> = {
  [OTP_FLOW.SIGNUP]: { origin: "signup", channel: "mobile" },
  [OTP_FLOW.VERIFY_EXISTING]: { origin: "details page", channel: "mobile" },
  [OTP_FLOW.UPDATE_PHONE_NUMBER]: {
    origin: "update phone number",
    channel: "dynamic",
  },
  [OTP_FLOW.WITHDRAW]: { origin: "withdraw", channel: "mobile" },
} as const;
